import { createEffect } from 'effector';
import { createForm } from '@unicorn/effector-form';
import { PageGate } from '../page';
import { sduiNewVesion } from './api';

const newVersion = localStorage.getItem('ticketsNewVersion') === 'new' ? true : false;
export const ticketsVersionForm = createForm<{ newVersion: boolean }>({
  initialValues: { newVersion },
  editable: true,
  debug: true,
  resetOn: PageGate.close,
});

export const fxSwitchToCustomFields = createEffect<void, void, Error>().use(
  sduiNewVesion.switchToCustomFields
);

export const saveIsNewTicketsVersionToLocalStorage = createEffect<boolean, void>().use(
  (isNewVersion) => {
    if (isNewVersion) {
      fxSwitchToCustomFields();
    }

    localStorage.setItem('ticketsNewVersion', isNewVersion ? 'new' : 'old');
  }
);
